import { Component, input, signal, inject } from '@angular/core';
import { Location } from '@lp-ui-lib';
import { DateFormatSettings } from '@lp-ui-lib';
import { HistoryItemDetail } from '@lp-ui-lib';
import { I18nService } from '@lp-ui-lib';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { DatePipe } from '@angular/common';
import { GLOBAL_CONSTANT } from '@lp-ui-lib';
import { DATE_TIME_FORMATE } from '@lp-ui-lib';
import { UiService } from '@lp-ui-lib';

@Component({
  selector: 'app-history-item',
  imports: [NzModalModule, NzIconModule, DatePipe],
  templateUrl: './history-item.html',
  styleUrl: './history-item.scss',
})
export class HistoryItemComponent {
  overlayImage: any;
  src = input<string | null>(null);
  item = input<HistoryItemDetail | any>(null);
  asset = input<Location | null>(null);
  collapsible = signal<boolean>(true);
  shadow = input<boolean>(false);
  dateFormat = input<DateFormatSettings | null>(null);

  public i18n = inject(I18nService);
  public Ui = inject(UiService);

  get Documentation(): boolean {
    const item = this.item();
    return item?.type === GLOBAL_CONSTANT.HISTORY_ITEM.TYPE.DOCUMENTATION;
  }
  get Red(): boolean {
    const item = this.item();
    return item?.display === GLOBAL_CONSTANT.HISTORY_ITEM.DISPLAY.CRITICAL;
  }
  get Yellow(): boolean {
    const item = this.item();
    return item?.display === GLOBAL_CONSTANT.HISTORY_ITEM.DISPLAY.WARNING;
  }
  get Green(): boolean {
    const item = this.item();
    return item?.display === GLOBAL_CONSTANT.HISTORY_ITEM.DISPLAY.WORKING;
  }
  get Grey(): boolean {
    const item = this.item();
    return item?.display === GLOBAL_CONSTANT.HISTORY_ITEM.DISPLAY.INACTIVE;
  }

  get Open(): boolean {
    const item = this.item();
    return item?.open || !this.collapsible;
  }

  get DateFormat(): string {
    const format = this.dateFormat();
    return format?.formatString === DATE_TIME_FORMATE.MMDDYYYY
      ? DATE_TIME_FORMATE.MMDDYYYY_H_MM_A
      : DATE_TIME_FORMATE.DDMMYYYY_HH_MM;
  }

  get Message(): string {
    const item = this.item();
    return this.enrichMessage(this.i18n.parse(item?.message));
  }
  detailedhistory = true as boolean;

  readonly isMobile: boolean = false;
  readonly isTablet: boolean = false;
  readonly isDesktop: boolean = true;

  enrichMessage(message: string) {
    const asset = this.asset();
    return asset
      ? message
          .replace('{ObjectName}', asset?.objectName)
          .replace('{Objektname}', asset?.objectName)
      : message;
  }

  // ngAfterViewInit(): void {
  //  this.ui.OnOrientationChange.subscribe(() => this.changeRef.detectChanges());
  // }

  openFile(file: any) {
    window.open(file.url, '_black', 'noreferrer');
  }

  onPhotoLoadingError(photo: any): void {
    const item = this.item();
    if (item?.details?.photos) {
      item.details.photos = item.details.photos.filter(
        (_photo: any) => _photo.picture !== photo.picture
      );
    }
  }
}
